var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-form", { ref: "form" }, [
    !_vm.isKlient
      ? _c(
          "div",
          [
            _c("v-autocomplete", {
              ref: "ico",
              staticClass: "dynamic-input-control",
              class: {
                validated:
                  _vm.displayValidated && !_vm.hasError && !_vm.errorMessages,
                required: true,
                readonly: _vm.readonly
              },
              attrs: {
                errorMessages: _vm.errorMessages,
                value: _vm.ico,
                outlined: "",
                items: _vm.items,
                loading: _vm.isLoading,
                "hide-no-data": "",
                label: "IČO",
                "append-icon": _vm.isDisabled ? "" : "mdi-chevron-down",
                "search-input": _vm.icoSearch,
                disabled: _vm.isDisabled,
                rules: _vm.getRules,
                readonly: _vm.isLoading || _vm.isDisabled,
                "return-object": "",
                "item-text": "ico",
                "item-value": "ico"
              },
              on: {
                input: function(newVal) {
                  _vm.setDirty(true)
                  _vm.updateIco(newVal)
                },
                "update:searchInput": function($event) {
                  _vm.icoSearch = $event
                },
                "update:search-input": function($event) {
                  _vm.icoSearch = $event
                }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "item",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c("div", { staticClass: "d-flex w100" }, [
                          _c("div", { staticClass: "d-flex mr-25px" }, [
                            _c(
                              "div",
                              _vm._l(
                                _vm.generateMaskTextArray(
                                  _vm.icoSearch,
                                  item.ico
                                ),
                                function(i, index) {
                                  return _c(
                                    "span",
                                    {
                                      key: index,
                                      staticClass: "v-center-text",
                                      class: { "v-list-item__mask": i.mask }
                                    },
                                    [_vm._v(" " + _vm._s(i.text) + " ")]
                                  )
                                }
                              ),
                              0
                            )
                          ]),
                          _c(
                            "span",
                            {
                              staticClass:
                                "f14 pl-2px ico-item-cor v-center-text"
                            },
                            [_vm._v(_vm._s(item.snazov))]
                          )
                        ])
                      ]
                    }
                  }
                ],
                null,
                false,
                1028337459
              )
            }),
            _c("v-autocomplete", {
              ref: "obch_meno",
              staticClass: "dynamic-input-control",
              class: {
                validated:
                  _vm.displayValidated && !_vm.hasError && !_vm.errorMessages,
                required: true,
                readonly: _vm.readonly
              },
              attrs: {
                errorMessages: _vm.errorMessages,
                value: _vm.obchodneMeno,
                outlined: "",
                items: _vm.items,
                loading: _vm.isLoading,
                "hide-no-data": "",
                label: "Obchodné meno/Meno a priezvisko",
                "append-icon": _vm.isDisabled ? "" : "mdi-chevron-down",
                "search-input": _vm.obchodneMenoSearch,
                disabled: _vm.isDisabled,
                rules: _vm.getRules,
                readonly: _vm.isLoading || _vm.isDisabled,
                "return-object": "",
                "item-text": "snazov",
                "item-value": "snazov"
              },
              on: {
                input: function(newVal) {
                  _vm.setDirty(true)
                  _vm.updateObchM(newVal)
                },
                "update:searchInput": function($event) {
                  _vm.obchodneMenoSearch = $event
                },
                "update:search-input": function($event) {
                  _vm.obchodneMenoSearch = $event
                }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "item",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c("div", { staticClass: "d-flex w100" }, [
                          _c(
                            "div",
                            {
                              staticClass: "d-flex mr-25px w250px",
                              staticStyle: { overflow: "hidden" }
                            },
                            [
                              _c(
                                "div",
                                _vm._l(
                                  _vm.generateMaskTextArray(
                                    _vm.obchodneMenoSearch,
                                    item.snazov
                                  ),
                                  function(i, index) {
                                    return _c(
                                      "span",
                                      {
                                        key: index,
                                        staticClass: "v-center-text",
                                        class: { "v-list-item__mask": i.mask }
                                      },
                                      [_vm._v(" " + _vm._s(i.text) + " ")]
                                    )
                                  }
                                ),
                                0
                              )
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "v-center-text w70px ml-auto" },
                            [_vm._v(_vm._s(item.ico))]
                          )
                        ])
                      ]
                    }
                  }
                ],
                null,
                false,
                4026071240
              )
            })
          ],
          1
        )
      : _c(
          "div",
          [
            _c("v-combobox", {
              ref: "ico",
              staticClass: "dynamic-input-control",
              class: {
                validated:
                  _vm.displayValidated && !_vm.hasError && !_vm.errorMessages,
                readonly: _vm.readonly
              },
              attrs: {
                errorMessages: _vm.errorMessages,
                value: _vm.ico,
                outlined: "",
                items: _vm.items,
                loading: _vm.isLoading,
                "hide-no-data": "",
                label: "IČO",
                "append-icon": _vm.isDisabled ? "" : "mdi-chevron-down",
                "search-input": _vm.icoSearch,
                disabled: _vm.isDisabled,
                readonly: _vm.isLoading || _vm.isDisabled,
                "return-object": "",
                "item-text": "ico",
                "item-value": "ico"
              },
              on: {
                input: function(newVal) {
                  _vm.setDirty(true)
                  _vm.updateIco(newVal)
                },
                "update:searchInput": function($event) {
                  _vm.icoSearch = $event
                },
                "update:search-input": function($event) {
                  _vm.icoSearch = $event
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "item",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "d-flex w100" }, [
                        _c("div", { staticClass: "d-flex mr-25px" }, [
                          _c(
                            "div",
                            _vm._l(
                              _vm.generateMaskTextArray(
                                _vm.icoSearch,
                                item.ico
                              ),
                              function(i, index) {
                                return _c(
                                  "span",
                                  {
                                    key: index,
                                    staticClass: "v-center-text",
                                    class: { "v-list-item__mask": i.mask }
                                  },
                                  [_vm._v(" " + _vm._s(i.text) + " ")]
                                )
                              }
                            ),
                            0
                          )
                        ]),
                        _c(
                          "span",
                          {
                            staticClass: "f14 pl-2px ico-item-cor v-center-text"
                          },
                          [_vm._v(_vm._s(item.snazov))]
                        )
                      ])
                    ]
                  }
                }
              ])
            }),
            _c("v-combobox", {
              ref: "obch_meno",
              staticClass: "dynamic-input-control",
              class: {
                validated:
                  _vm.displayValidated && !_vm.hasError && !_vm.errorMessages,
                required: true,
                readonly: _vm.readonly
              },
              attrs: {
                errorMessages: _vm.errorMessages,
                value: _vm.obchodneMeno,
                outlined: "",
                items: _vm.items,
                loading: _vm.isLoading,
                "hide-no-data": "",
                label: "Obchodné meno/Meno a priezvisko",
                "append-icon": _vm.isDisabled ? "" : "mdi-chevron-down",
                "search-input": _vm.obchodneMenoSearch,
                disabled: _vm.isDisabled,
                rules: _vm.getRules,
                readonly: _vm.isLoading || _vm.isDisabled,
                "return-object": "",
                "item-text": "snazov",
                "item-value": "snazov"
              },
              on: {
                input: function(newVal) {
                  _vm.setDirty(true)
                  _vm.updateObchM(newVal)
                },
                "update:searchInput": function($event) {
                  _vm.obchodneMenoSearch = $event
                },
                "update:search-input": function($event) {
                  _vm.obchodneMenoSearch = $event
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "item",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "d-flex w100" }, [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex mr-25px w250px",
                            staticStyle: { overflow: "hidden" }
                          },
                          [
                            _c(
                              "div",
                              _vm._l(
                                _vm.generateMaskTextArray(
                                  _vm.obchodneMenoSearch,
                                  item.snazov
                                ),
                                function(i, index) {
                                  return _c(
                                    "span",
                                    {
                                      key: index,
                                      staticClass: "v-center-text",
                                      class: { "v-list-item__mask": i.mask }
                                    },
                                    [_vm._v(" " + _vm._s(i.text) + " ")]
                                  )
                                }
                              ),
                              0
                            )
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "v-center-text w70px ml-auto" },
                          [_vm._v(_vm._s(item.ico))]
                        )
                      ])
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }